module.exports = __webpack_public_path__ + "img/search.fae746e7.svg";